import styled from "styled-components";

const Container = styled.section`
	min-height: 550px;
`;

const CustomLayout = ({ children }) => {
    return (
        <Container className=" w-full h-screen  bg-gray-100 ">
            <div className="w-full h-full flex flex-nowrap   bg-white ">{children}</div>
        </Container>
    );
};

export default CustomLayout;
